"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Mon Apr 08 2019
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * WindowItemTransferValidationDTOConverter
 *
 * @author Tomáš Leity
 */


var WindowItemTransferValidationDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowItemTransferValidationDTOConverter, _DataObjectConverter_);

  function WindowItemTransferValidationDTOConverter() {
    _classCallCheck(this, WindowItemTransferValidationDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemTransferValidationDTOConverter).apply(this, arguments));
  }

  return WindowItemTransferValidationDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowItemTransferValidationDTOConverter = WindowItemTransferValidationDTOConverter;